import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/base/SEOMeta';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

export default function HomePage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '换妻一族｜开放关系探索者的深度指南',
    description: '换妻一族是指夫妻双方经协商同意、相互交换伴侣进行性探索的成人群体。深度解析心理动机、安全守则、法律边界与社群文化。',
    url: 'https://www.example.com',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '换妻一族',
      url: 'https://www.example.com',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.example.com',
        },
      ],
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title="换妻一族｜开放关系探索者的深度指南"
        description="换妻一族是指夫妻双方经协商同意、相互交换伴侣进行性探索的成人群体。深度解析心理动机、安全守则、法律边界与社群文化，帮助好奇者理性了解这一成人亚文化现象。"
        keywords="换妻一族,换妻文化,开放关系,成人亚文化,夫妻性探索,伴侣交换,换妻群体"
        canonicalUrl="https://www.example.com"
        ogType="website"
      />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}